import { PropostaConfiguracao } from 'models/PropostaConfiguracao';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import api from 'services/api';
import PropostaModel from 'models/Proposta';
import { LocationState } from '../..';

export default function Cabecalho(): JSX.Element {
  const location = useLocation<LocationState>();
  const { proposta, propostaVersao } = location.state;

  const [hierarquiaDomSGE, setHierarquiaDomSGE] = useState<any>({});

  const [propostaCliente, setPropostaCliente] = useState<PropostaModel>(
    {} as PropostaModel,
  );

  async function getHierarquia() {
    const response = await api.get(
      `/proposta/hierarquia/${proposta.usuario.pessoaDomSGE}/${propostaVersao.id}`,
    );

    setHierarquiaDomSGE(response.data);
  }

  const { data: queryConfiguracoes } = useQuery(
    ['proposta-configuracoes', propostaVersao.id],
    async () => {
      async function getConfiguracoes(): Promise<PropostaConfiguracao[]> {
        const response = await api.get(
          `/proposta/versao/${propostaVersao.id}/configuracoes`,
        );
        return response.data;
      }

      const dataStatus = await getConfiguracoes();
      return dataStatus;
    },
    { staleTime: 1000 * 60 * 10, enabled: !!propostaVersao.id },
  );

  async function carregaConfiguracoes() {
    const response = await api.get(`/proposta/${proposta.id}`);
    const propostaCompleta = response.data as PropostaModel;
    setPropostaCliente(propostaCompleta);
  }

  useEffect(() => {
    getHierarquia();
  }, []);

  useEffect(() => {
    if (propostaVersao.id) {
      carregaConfiguracoes();
    }
  }, [propostaVersao.id]);

  return (
    <div className="d-flex w-100 align-items-start" style={{ gap: 40 }}>
      <div className="d-flex w-100 align-items-start" style={{ gap: 35 }}>
        <div className="d-flex flex-column">
          <h4 className="mb-0">Proposta {proposta.id}</h4>

          <small>
            Versão {propostaVersao.versao} | Configurações{' '}
            {queryConfiguracoes
              ?.map((config: PropostaConfiguracao) => config.orcamentoId)
              .join(', ')}
          </small>
        </div>

        <div className="d-flex flex-column">
          <small>
            <strong>Localização:</strong>{' '}
            {proposta.PropostaLocalObra?.municipio} /{' '}
            {proposta.PropostaLocalObra?.uf}
          </small>

          <small>
            <strong>Usuário:</strong> {proposta.usuario.nome}
          </small>

          {hierarquiaDomSGE?.pessoaCargoDesc && (
            <small>
              <strong>Função:</strong> {hierarquiaDomSGE.pessoaCargoDesc}
            </small>
          )}
        </div>

        <div className="d-flex flex-column">
          {hierarquiaDomSGE?.pessoaRazao && (
            <small>
              <strong>Empresa:</strong> {hierarquiaDomSGE.pessoaRazao}
            </small>
          )}

          {hierarquiaDomSGE?.pessoaSupRazao && (
            <small>
              <strong>Superior:</strong> {hierarquiaDomSGE.pessoaSupRazao} |{' '}
              {hierarquiaDomSGE.pessoaSupCargoDesc}
            </small>
          )}
        </div>

        <div className="d-flex flex-column">
          <small>
            <strong>GNF:</strong> {proposta.codigoOportunidadeDomsge}
          </small>

          {propostaCliente.pessoaGnf && (
            <small>
              <strong>Cadastro Inicial:</strong>{' '}
              {propostaCliente.pessoaGnf.codigoDomsge} -{' '}
              {propostaCliente.pessoaGnf.razaoSocial}
            </small>
          )}

          {(propostaCliente.pessoaGnf?.id ?? 0) !==
            (propostaCliente.pessoa?.id ?? 0) && (
            <small>
              <strong>Definitivo Proposta:</strong>{' '}
              {propostaCliente.pessoa?.codigoDomsge} -{' '}
              {propostaCliente.pessoa?.razaoSocial}
            </small>
          )}
        </div>
      </div>
    </div>
  );
}
